import { ArticleHeading2, ArticleParagraph1, ArticleParagraph2, useDeviceType } from '@cian/ui-kit';
import * as style from './Review.css';
import { clsx } from 'clsx';
import { EGender, TReview } from 'shared/types/reviews';

interface IReviewProps extends TReview {
  onClickButton: (id: number) => void;
}

export const Review: React.FC<IReviewProps> = ({ onClickButton, id, gender, name, shortReview, moreInfo }) => {
  const device = useDeviceType();

  return (
    <div className={clsx(style['item'], style[device])}>
      <div className={style['head']}>
        <div className={clsx(style['image'], style[gender === EGender.Woman ? 'woman' : 'man'])} />
        <div>
          <div className={style['title']}>
            <ArticleHeading2>{name}</ArticleHeading2>
          </div>
          <div>
            <ArticleParagraph2>{moreInfo}</ArticleParagraph2>
          </div>
        </div>
      </div>
      <div className={style['content']}>
        <ArticleParagraph1>{shortReview}</ArticleParagraph1>
      </div>
      <div className={style['btn-container']} onClick={() => onClickButton(id)}>
        <button className={style['show-more']}>Развернуть</button>
        <div className={style['arrow']} />
      </div>
    </div>
  );
};
